<template>
  <v-container>
    <v-row  large v-for="(menuItem,index) of navigation" :key="index" v-useCase="menuItem.useCase" v-if="allowedAtLeastOneNestedItem(menuItem)" no-gutters>
      <v-col
        v-if="menuItem.data.length == 0">
      <v-btn
        dense
        dark
        text
        tile
        class="text-caption font-weight-light px-1 mr-2"
        @click="handleMenuItemRoute(menuItem)"
      >
        <v-icon dense class="mr-1" left>{{menuItem.icon}}</v-icon>
        {{translateName(menuItem.name, menuItem.translatePath)}}
      </v-btn>
      </v-col>
      <v-col
      v-else>
      <v-menu 
      class="ma-0 pa-0" :close-on-content-click="true" offset-y dense>
      <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            dark
            text
            tile
            class="text-caption font-weight-light px-1"
          >
            <v-icon dense class="mr-1" left>{{menuItem.icon}}</v-icon>
            {{translateName(menuItem.name, menuItem.translatePath)}}
            <v-icon dense class="ml-0 mr-2">keyboard_arrow_down</v-icon>
          </v-btn>
        </template>
        <v-list dense class="text-caption">
          <v-list-item
            v-useCase="subMenuItem.useCase"
            v-for="(subMenuItem,subMenuIndex) of menuItem.data"
            :key="subMenuIndex"
            exact
            @click="handleMenuItemRoute(subMenuItem)"
          >
            <v-list-item-icon class="mr-2">
              <v-icon left color="primary" dense>{{subMenuItem.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{ translateName(subMenuItem.content, menuItem.translatePath) }}</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import navigation from '@/resource/navigation.json'
import { mapState } from 'vuex'
import { useCaseMap } from '@/utils/useCase/useCaseMap'

export default {
  methods: {
    translateName(toTranslate, source) {
      return translate(toTranslate, source)
    },
    handleMenuItemRoute(subMenuItem) {
      this.$router.push({
        name: subMenuItem.routeName,
        params: { slug: subMenuItem.slug, page: subMenuItem.slug }
      })
    },
    allowedAtLeastOneNestedItem(menuItem) {
      if(menuItem.name == "Reports" && !this.checkIfUserHasReports()) {
        return false;
      }
      
      if (!menuItem.data.length) {
        return true
      }

      let nestedUseCases = menuItem.data.map(x => x.useCase)
      const allowedUseCaseIds = JSON.parse(this.userDecoded.UserData)
        .AllowedUseCaseIds

      let allowed = []

      for (let useCase of nestedUseCases) {
        
        if (
          (
          useCaseMap[useCase] &&
          allowedUseCaseIds.includes(useCaseMap[useCase]) || useCase == "None")
        ) {
          allowed.push(useCaseMap[useCase])
        }
      }

      return allowed.length > 0
    },
    checkIfUserHasReports() {
      var reportsUseCaseIds = [];
      Object.keys(useCaseMap)
        .forEach(x => {
          if(x.toLowerCase().indexOf("report") != -1) {
            reportsUseCaseIds.push(useCaseMap[x]);
          }
        });

      const allowedUseCaseIds = JSON.parse(this.userDecoded.UserData).AllowedUseCaseIds;

      return reportsUseCaseIds.some(x => allowedUseCaseIds.includes(x));
    }
  },
  computed: {
    navigation() {
      if (this.isUserDriverRole) {
        return navigation.driverNavList
      }
      return navigation.navList
    },
    bPoint() {
      return this.$vuetify.breakpoint
    },
    ...mapState('user', ['userDecoded', 'isUserDriverRole'])
  }
}
</script>

<style lang="scss" scoped>
.v-list {
  max-height: 100vh;
  overflow-y: auto;
}
</style>